import { useQuery } from "$hooks";
import { NotificationsConfig } from "$config";
import { HAS_UNREAD_COMPANY_NOTIFICATIONS } from "$queries";
import { useCurrentUser } from "./useCurrentUser";
import { ApprovalStatus } from "$interfaces/ApprovalStatus";

export const useHasUnreadCompanyNotifications = () => {
  const currentUser = useCurrentUser();
  const company = currentUser.data?.getCurrentUser?.company;
  const isApproved = company?.approvalStatus === ApprovalStatus.approved;
  const isRejected = company?.approvalStatus === ApprovalStatus.rejected;
  const shouldSkipQuery = !(isApproved || isRejected);

  const response = useQuery<{}, IResponse>(HAS_UNREAD_COMPANY_NOTIFICATIONS, {
    pollInterval: NotificationsConfig.pollInterval,
    skip: shouldSkipQuery
  });
  return response.data && response.data.hasUnreadCompanyNotifications.hasUnreadNotifications;
};

interface IResponse {
  hasUnreadCompanyNotifications: { hasUnreadNotifications: boolean };
}
